import { Moon, Sun, Monitor } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useTheme, type ThemeMode } from "@/lib/theme";

export function ThemeToggle({ className }: { className?: string }) {
  const { mode, setMode } = useTheme();

  function cycleTheme() {
    const order: ThemeMode[] = ["light", "dark", "system"];
    const next = order[(order.indexOf(mode) + 1) % order.length]!;
    setMode(next);
  }

  const ThemeIcon = mode === "dark" ? Moon : mode === "light" ? Sun : Monitor;

  return (
    <Button
      variant="ghost"
      size="icon"
      className={className}
      onClick={cycleTheme}
      aria-label={`Theme: ${mode}. Click to change.`}
      title={`Theme: ${mode}`}
    >
      <ThemeIcon className="h-4 w-4" />
    </Button>
  );
}
